import React, { useState } from "react";
import { TextField, Box, InputAdornment } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
//import axios from "../../utils/axiosInstance";

const useStyles = () => (theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  job: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});

const SearchCompany = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const loading = open && companies.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const response = await axios.get("/wp-json/api/v2/entity_titles", {
        params: {
          search_by: "companies",
        },
      });
      const companies = response.data;

      if (active) {
        setCompanies(companies);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  const handleInputChange = async (event, value, reason) => {
    //check if we have the data:
    if (value.length > 2) {
      (async () => {
        const response = await axios.get("/wp-json/api/v2/entity_titles", {
          params: {
            search: value,
            search_by: "companies",
          },
        });
        const companies = response.data;
        setCompanies(companies);
      })();
    } else {
      (async () => {
        const response = await axios.get("/wp-json/api/v2/jobs_title", {
          params: {
            search_by: "companies",
          },
        });
        const companies = response.data;
        setCompanies(companies);
      })();
    }

    //props.linkToJobId(value.id)
  };

  return (
    <Box className={classes.root}>
      {props.searchMode ? (
        <Autocomplete
          id="companiesSearch"
          style={{ width: props.fullWidth ? "auto" : 400 }}
          open={open}
          fullWidth={props.fullWidth ? true : false}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          onChange={(event, value, reason) => props.linkToCompany(value.id)}
          onInputChange={handleInputChange}
          //getOptionSelected={(job, value) => props.linkToCompany(value.id)}
          filterOptions={(options, params) => {
            if (params.inputValue === "") return options;
            return options.filter(
              (job) =>
                job.id.toString().includes(params.inputValue) ||
                job.title.includes(params.inputValue)
            );
          }}
          getOptionSelected={(company, value) => company.id === value.id}
          getOptionLabel={(company) => company.title}
          options={companies}
          loading={loading}
          renderOption={(company) => (
            <React.Fragment>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: 12, marginRight: theme.spacing(1) }}>
                  Company ID:{company.id}
                </span>
                {company.title}
              </div>
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Find Company"
              variant={props.variant ? props.variant : "outlined"}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      ) : (
        <TextField
          label="Company ID"
          id="companyId"
          className={classes.textField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">ID</InputAdornment>
            ),
          }}
          onBlur={props.linkToCompany}
          variant="outlined"
        />
      )}
    </Box>
  );
};
export default SearchCompany;
